import { render, staticRenderFns } from "./NavigationCustomTag.vue?vue&type=template&id=10ef35cc&"
import script from "./NavigationCustomTag.vue?vue&type=script&lang=js&"
export * from "./NavigationCustomTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports